import { Component, Input, AfterViewInit } from '@angular/core';

@Component({
  selector: 'apc-navbar-small',
  templateUrl: './navbar-small.component.html',
  styleUrls: ['./navbar-small.component.scss']
})
export class NavbarSmallComponent implements AfterViewInit {
  @Input() public items: any[];
  @Input() public color: string;
  @Input() public permission: string;
  @Input() public notFlexMenu: boolean = false;

  ngAfterViewInit() {
    var navbar = document.getElementById('navbar-small');
    var menus = navbar.getElementsByTagName('a');
    if(menus.length == 1 && !window.location.pathname.split('/')[4]) {
      menus[0].click();
    } 
  }

}
